module.exports = __webpack_public_path__ + "static/media/rectangle_color.92703d0c.svg";